import { render } from "./javascript-course.vue?vue&type=template&id=0a892c45&scoped=true"
import script from "./javascript-course.vue?vue&type=script&lang=js"
export * from "./javascript-course.vue?vue&type=script&lang=js"

import "./javascript-course.vue?vue&type=style&index=0&id=0a892c45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a892c45"]])

export default __exports__